module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-68.824d9a61.svg";